import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";
import packageJson from '../package.json';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: "https://37755b7e0e778925baa0d40d0cb9fcc9@sentry.megakit.pro/21",
  release: packageJson.version,
  tracesSampleRate: environment.production ? 0.1 : 1.0,
  environment: environment.production ? 'production' : 'development',
  sendDefaultPii: true,
  beforeSend(event, hint) {
    const error = hint?.originalException as any;

    if (
      (error instanceof Error &&
      error.name === 'TurnstileError') ||
      typeof error === 'string' && error.includes('TurnstileError')
    ) {
      Sentry.captureException(new Error('Turnstile error suppressed: ' + ( typeof error !== "string" ? error?.message : '-')), {
        level: 'error'
      });
      return null;
    }

    return event;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  Sentry.captureException(event.reason);
});

window.addEventListener('error', (event) => {
  Sentry.captureException(event.error ?? event.message);
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
